<template>
  <div>
    <div class="logic-flow-view">
      <!-- 画布 -->
      <div id="LF-view" ref="container"></div>
    </div>
  </div>
</template>
<script>
import LogicFlow from '@logicflow/core'
import { Snapshot, MiniMap } from '@logicflow/extension'
import '@logicflow/core/dist/style/index.css'
import '@logicflow/extension/lib/style/index.css'

import {
  registerStart,
  registerUser,
  registerEnd,
  registerPush,
  registerDownload,
  registerPolyline,
  registerTask,
  registerConnect,
  registerSetting,
  registerConfluence,
  registerDistributary,
  registerExclusiveGateway,
} from './registerNode'
import {toTurboData} from "./Util/AdpterForTurbo";
import Http from "../common/Http";
import FlowSheet from "./lib/FlowSheet";

export default {
  name: 'BpmnViewComponents',
  components: {  },
  props:{
    task_id:{
      type:Number|String,
      default() {
        return "";
      }
    },
    graph_data:{
      type:Object|Array,
      default() {
        return {};
      }
    },
  },
  data () {
    return {
      lf: null,
      showAddPanel: false,
      addPanelStyle: {
        top: 0,
        left: 0
      },
      nodeData: null,
      addClickNode: null,
      clickNode: null,
      graphData: null,
      dataVisible: false,
      config: {
        background: {
          backgroundColor: '#f7f9ff',
        },
        grid: {
          size: 10,
          visible: false
        },
        keyboard: {
          enabled: false,
        },
        edgeTextDraggable: false,
        hoverOutline: false,
        stopZoomGraph: true, // 禁止缩放
        stopScrollGraph: false, // 禁止鼠标滚动移动画布
        isSilentMode: true,
        stopMoveGraph:false,
        hideAnchors:true,
        adjustEdgeMiddle:false,
        adjustNodePosition:false,
        metaKeyMultipleSelected:false

      },
      moveData: {},
      show_flow_sheet_status:false,
      form:{
        name:"",
        image:"",
        graph_data:"",
      },
      host_url:"",
      uploadUrl:"",
      flow_process_steps_list:[]
    }
  },
  mounted () {
    this.host_url=Http.getBaseURL();
    this.uploadUrl=this.host_url+"/flow/UserRole/uploadFile";
    this.$_initLf()
    this.getData();
  },
  watch:{
    // sheet_id(n) {
    //   this.initData()
    // }
  },
  methods: {
    initData(){
      this.$_sheet_id=this.sheet_id;
      this.$_task_id=this.task_id;
      this.getData();
    },
    $_initLf () {
      // 画布配置
      const lf = new LogicFlow({
        ...this.config,
        plugins: [
          MiniMap,
          Snapshot,
        ],
        container: this.$refs.container,
      })
      this.lf = lf

      window.lf=lf;
      // 设置主题
      lf.setTheme({
        circle: {
          stroke: '#000000',
          strokeWidth: 1,
          outlineColor: '#88f',
        },
        rect: {
          outlineColor: '#88f',
          strokeWidth: 1
        },
        polygon: {
          strokeWidth: 1
        },
        polyline: {
          stroke: '#000000',
          hoverStroke: '#000000',
          selectedStroke: '#000000',
          outlineColor: '#88f',
          strokeWidth: 1
        },
        nodeText: {
          color: '#000000'
        },
        edgeText: {
          color: '#000000',
          background: {
            fill: '#f7f9ff'
          }
        },
      })
      this.$_registerNode()
    },
    // 自定义
    $_registerNode () {
      registerStart(this.lf)
      registerUser(this.lf)
      registerEnd(this.lf)
      registerPush(this.lf, this.clickPlus, this.mouseDownPlus)
      registerDownload(this.lf)
      registerPolyline(this.lf)
      registerTask(this.lf)
      registerConnect(this.lf)
      registerSetting(this.lf)
      registerConfluence(this.lf)
      registerDistributary(this.lf)
      registerExclusiveGateway(this.lf)
      this.$_render()
    },
    $_render () {
      if(this.graph_data){
        this.lf.render(this.graph_data)
      }else {
        this.lf.render()
      }
      this.$_LfEvent()
    },
    $_LfEvent () {
      var that=this;
      that.lf.on('node:click', ({data}) => {
        console.log('node:click', data)
        that.$data.clickNode = data
      })
      that.lf.on('edge:click', ({data}) => {
        console.log('edge:click', data)
        that.$data.clickNode = data
      })
      that.lf.on('element:click', () => {
        that.hideAddPanel()
      })
      that.lf.on('edge:add', ({data}) => {
        // console.log('edge:add', data)
      })
      that.lf.on('node:mousemove', ({data}) => {
        // console.log('node:mousemove')
        that.moveData = data
      })
      that.lf.on('blank:click', (e) => {
        console.log(e)
        that.hideAddPanel()
      })
      that.lf.on('connection:not-allowed', (data) => {
        that.$message({
          type: 'error',
          message: data.msg
        })
      })
      that.lf.on('node:mousemove', () => {
        // console.log('on mousemove')
      })
    },
    clickPlus (e, attributes) {
      e.stopPropagation()
      const { clientX, clientY } = e
      console.log(clientX, clientY)
      this.$data.addPanelStyle.top = (clientY - 40) + 'px'
      this.$data.addPanelStyle.left = clientX + 'px'
      this.$data.showAddPanel = true
      this.$data.addClickNode = attributes
    },
    mouseDownPlus (e, attributes) {
      e.stopPropagation()
      console.log('mouseDownPlus', e, attributes)
    },
    hideAddPanel () {
      this.$data.showAddPanel = false
      this.$data.addPanelStyle.top = 0
      this.$data.addPanelStyle.left = 0
      this.$data.addClickNode = null
    },
    getData(){
      const that = this;
      let where={task_id: that.task_id};
      Http.get("flow/FlowProcessSteps/getList",{
        where:JSON.stringify(where),
        page: 1,
        page_size: 50
      },res=>{
        if(res.code) {
          that.flow_process_steps_list=res.data.list
          that.renderProcessSteps();
        }
      })
    },
    renderProcessSteps(){
      const that = this;
      if(that.graph_data){
        let fs=new FlowSheet(reJson(that.graph_data))
        let exclusiveGateway_node_value=that.flow_process_steps_list.filter(ret=>ret.business_type==2).map(ret=>ret.node_value);
        let node_list=fs.chooseAllSequenceList(exclusiveGateway_node_value);

        let graph_data=reJson(that.graph_data);


        graph_data.nodes=graph_data.nodes.map(ret=>{
          ret.properties.throughObj=that.flow_process_steps_list.filter(res=>res.node_id==ret.id)
          return ret;
        })
        graph_data.edges=graph_data.edges.map(ret=>{
          ret.properties.throughObj=that.flow_process_steps_list.filter(res=>res.node_id==ret.id)
          return ret;
        })
        console.log(graph_data)
      }

    }
  }
}
const reJson = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}
</script>
<style lang="scss">
@import "../common";
.logic-flow-view {
  height: calc( 100vh - 100px );
  width: calc( 100vw - 150px );
  position: relative;

  .panel-property{
    position: absolute;
    width: 400px;
    right: 5px;
    top: 100px;
    background-color: #FFFFFF;
  }
}
.demo-control{
  position: absolute;
  top: 5px;
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 2;
  display: inline-table;
}
#LF-view{
  width: 100%;
  height: 100%;
  outline: none;
  //margin-left: 50px;
}
.add-panel {
  position: absolute;
  z-index: 11;
  background-color: white;
  padding: 10px 5px;
}
.el-drawer__body {
  height: 80%;
  overflow: auto;
  margin-top: -30px;
  z-index: 3;
}
</style>




// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/BpmnViewComponents.vue